import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import routers from "./router/index";
import pageHeader from "./components/header.vue";
import pageBack from './components/back.vue'
import store from '@/store';

import Vant from 'vant';

import 'vant/lib/index.css'; // 引入样式文件
Vue.use(Vant);
Vue.component('pageHeader', pageHeader)
Vue.component('pageBack', pageBack)
Vue.use(VueRouter)
    // // 3. 创建 router 实例，然后传 `routes` 配置
const router = new VueRouter({
    mode: 'hash',
    routes: routers
})

function setRem() {
    const html = document.documentElement;
    const width = window.innerWidth;
    let rem = 100; // 默认基准值，例如1rem = 100px
    if (width >= 2160) {
        rem = 100; // 设计稿宽度为750px时，1rem = 100px
    } else {
        rem = 100 * (width / 2160); // 根据视口宽度调整
    }
    html.style.fontSize = rem + 'px';
}

window.onresize = setRem;
setRem(); // 页面加载时也调用一次
// // 4. 通过 Vue.use() 明确地安装路由功能
// Vue.use(VueRouter);
// import { createApp } from "vue";
// const app = createApp(App);
// app.use(router)
// app.component("headNav", headNav)
// 5. 创建和挂载根实例。
// 通过 router 配置参数注入路由，让整个应用都有路由功能
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')